import React from 'react'
import FeaturesSection from '../../UAEPages/UAEPageComponents/FeaturesSection'
import { INDGroceryFeatures, OtherFeaturesDataGrocery, OtherFeaturesDataGroceryInd, } from '../../../constants/common'
import HeaderSection from '../../UAEPages/UAEPageComponents/HeaderSection'
import OtherFeatures from '../../UAEPages/UAEPageComponents/OtherFeatures'
import styles from '../../../styles/UAEPageComponents.module.css'
import NewFaqSection from '@/components/HomeLanding/HomeLandingComponents/NewFaqSection'
import BusinessUnlockSection from '@/components/HomeLanding/ComponentsIndiaPage/BusinessUnlockSection'
import ConnectWithUs from '@/components/HomeLanding/ComponentsIndiaPage/ConnectWithUs'
import AwardsSection from '@/components/HomeLanding/HomeLandingComponents/AwardsSection'
import NewsAndVideos from '@/components/HomeLanding/ComponentsIndiaPage/NewsAndVideos'
import ContqactSection from '../../UAEPages/UAEPageComponents/ContactSection'
import { OutletTypes } from '@/components/qbStrap'

const DesktopGrocery = () => {
  const INGroceryHeader = {
    useIndiaLogos: true,
    firstTitle: "POS Billing Software",
    secondTitle: "for Grocery Stores",
    description: <>
    <>A fast growing grocery store in India runs on everyday speed: peak hour rush, daily replenishment, and zero room for billing errors. QueueBuster is built for high-volume grocery stores where you need fast checkouts, tight stock control, and clear GST-ready records, without complicated setups.</> <br /> <br />
    <>From single kirana stores to multi-branch supermarkets, QueueBuster helps you bill faster, restock smarter, manage suppliers, track fast-moving items, and keep operations running even when connectivity drops. </>
    </>,
    images: {
      bgVector: "/assets/UAERetailPage/bgVector.svg",
      bgwidth: "42rem",
      bgheight: "40rem",
      bgtop: "17%",
      bgleft: "20%",
      bgbottom: "0%",
      bgright: "5%",
      bgzindex: "0",
      mainImage: {
        src: "/assets/uae-grocery/grocery_mainImg.webp",
        alt: "QueueBuster for Grocery",
        width: "41rem",
        height: "40rem",
        bottom: "0",
        right: "0"
      },
      img1: {
        src: "/assets/groceryInd/Schedule.svg",
        alt: "Quick Bill",
        width: "17rem",
        height: "17rem",
        top: "12rem",
        left: "12%",
        zindex: 10
      },
      img2: {
        src: "/assets/groceryInd/discount.svg",
        alt: "Schedule",
        width: "15rem",
        height: "5.5rem",
        bottom: "30%",
        left: "3%",
        zindex: 10
      },
      img3: {
        src: "/assets/groceryInd/Frame.svg",
        alt: "Plane Image",
        width: "26rem",
        height: "16rem",
        top: "23%",
        right: "-8rem"
      }

    }
  }

  const faqs = [
    {
      para: (
        <span style={{ width: "90%" }}>
          Is QueueBuster suitable for small kirana stores in India?
        </span>
      ),
      des: "Absolutely. QueueBuster is built to work for stores of all sizes, from a single-counter kirana to a growing chain of grocery outlets. Setup is simple, and you can start billing and tracking stock from day one without a lengthy onboarding process. As your store grows, the platform scales with you.",
      id: 1,
      activeIndex: 1,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          Does it support GST billing?
        </span>
      ),
      des: "Yes. QueueBuster generates fully GST-compliant invoices with CGST, SGST, and IGST breakdowns, HSN codes, and all required fields. It also produces GST-ready reports to simplify your monthly and quarterly filings.",
      id: 2,
      activeIndex: 0,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          Can it handle a large number of products?
        </span>
      ),
      des: "Yes. QueueBuster is built for high-SKU grocery environments. You can manage thousands of products across multiple categories, brands, and pack sizes, and bulk import your catalog to get started faster.",
      id: 3,
      activeIndex: 0,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          How does it help with stockouts?
        </span>
      ),
      des: "Real-time inventory updates and configurable low-stock alerts make sure you're restocking before shelves go empty. You can set reorder thresholds for every product, so alerts fire at the right moment, not after you've already missed sales.",
      id: 4,
      activeIndex: 0,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          Can it track expiry dates for perishables?
        </span>
      ),
      des: "Yes. QueueBuster tracks expiry at the batch level across all perishable categories. You get automatic alerts before items approach their expiry date, and expired products are blocked from billing to prevent compliance issues.",
      id: 5,
      activeIndex: 0,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          Does it work without internet connectivity?
        </span>
      ),
      des: "Yes. Billing continues in offline mode without interruption. As soon as connectivity returns, all transaction data syncs automatically, so no sale is ever lost due to a network issue.",
      id: 6,
      activeIndex: 0,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          Can I manage multiple grocery store branches from one account?
        </span>
      ),
      des: "Yes. QueueBuster supports multi-location operations with centralised stock visibility, branch-wise performance tracking, and consolidated reporting, all accessible from a single login.",
      id: 7,
      activeIndex: 0,
    },
    {
      para: (
        <span style={{ width: "90%" }}>
          Does it support UPI and digital payment modes?
        </span>
      ),
      des: "Yes. QueueBuster supports UPI, cash, debit/credit cards, digital wallets, and split payment options, making it easy to serve customers across all preferred payment modes.",
      id: 8,
      activeIndex: 0,
    },
  ]
  const OutletTypesData = [
    {
      image: "/assets/UAERetailPage/OutletTypesImg1.png",
      title: "Fashion & Apparel",
      hoverColor: "#F68E1E",
    },
    {
      image: "/assets/UAERetailPage/OutletTypesImg2.png",
      title: "Footwear",
      hoverColor: "#225590"
    },
    {
      image: "/assets/UAERetailPage/OutletTypesImg8.png",
      title: "Cosmetics",
      hoverColor: "#F68E1E",
    },
    {
      image: "/assets/UAERetailPage/OutletTypesImg3.png",
      title: "Accessories",
      hoverColor: "#225590"
    },
    {
      image: "/assets/UAERetailPage/OutletTypesImg4.png",
      title: "Home & Living",
      hoverColor: "#F68E1E",
    },
    {
      image: "/assets/UAERetailPage/OutletTypesImg5.png",
      title: "Carts & Kiosks",
      hoverColor: "#225590"
    },
    {
      image: "/assets/UAERetailPage/Restaurants.png",
      title: "Restaurants",
      hoverColor: "#F68E1E",
    },
    {
      image: "/assets/UAERetailPage/OutletTypesImg7.png",
      title: "Pet Store",
      hoverColor: "#225590"
    },

  ]

  return (
    <div style={{ fontFamily: 'GilroyMedium' }}>
      <HeaderSection data={INGroceryHeader} />

      <FeaturesSection
        data={INDGroceryFeatures}
        title={"Blissful Features of QueueBuster’s Grocery POS Solution!"} />

      <OtherFeatures
        data={OtherFeaturesDataGroceryInd}
        title={<>More Reasons Grocery <br />Owners Choose QueueBuster!</>} 
        />

     {/* <OutletTypes title={"Grocery Outlet Types"} data={OutletTypesData} /> */}

      <div className={styles.resposiveSections}>
          <AwardsSection />
      <div ><BusinessUnlockSection /></div>
      <div><ConnectWithUs /></div>
      </div>
      <div> <NewFaqSection FaqTableData={faqs} heading={"FAQs for India Grocery POS Software"}/>  </div>

      <div>
        <ContqactSection
        title="Still Have Questions?"
        description= {<>Tell us about your store and our team will help you figure out the right setup, <br /> whether you're running a small kirana or a growing grocery chain.</>}
        buttonText="Request a Callback"
      />
      </div>

      <div >
        <NewsAndVideos />
      </div>
    </div>
  )
}

export default DesktopGrocery
